import React from 'react';
import { Link } from 'react-router';

type WithUpsellLinkProps = {
  children: React.ReactNode;
  enableUpsell: boolean;
  upsellLink: string;
};

export const WithUpsellLink = ({
  children,
  enableUpsell,
  upsellLink,
}: WithUpsellLinkProps) => {
  if (enableUpsell) {
    return (
      <Link to={upsellLink}>
        <>{children}</>
      </Link>
    );
  }

  return <>{children}</>;
};
